import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const ToastWrapperStyled = styled.div`
  div {
    bottom: 24px;
    align-items: center;
  }

  div:nth-child(2) {
    align-items: start;
  }

  div + div {
    flex: 1;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    div {
      left: auto;
      right: 16px;
      top: 80px;
    }
  }
`;
